export const breackpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export const colors = {
  customBeige: "#c9b09a",
  customBgc: "#dbd0be",
  customWhite: "#f4eee3",
  customGrey: "#84735e",
  customBrown: "#885a3a",
  customLightBrown: "#a77d54",
  customActiveBgc: "#55555550",
};

export const textContent = {
  heading: "Авторські екскурсії Римом та околицями",
  main: "Рим - це живий музей під відкритим небом. Він захопить вас з першого погляду на Колізей і Пантеон; заінтригує рештками римських форумів та атмосферними двориками; вразить красою площ, церков, фонтанів, терас й зачарує смаком карбонари, піци Маргарити, джелато й тірамісу. \nА ще - це центр всесвітнього шопінгу, мистецьких подій та італійського «солодкого життя»! Рим не залишить вас байдужим, якщо знати куди йти, що дивитись та дегустувати. Саме в цьому я хочу бути вам корисною. Адже всі дороги ведуть в Рим.",
  about:
    "Привіт, я Ольга – твоя подруга в Римі та Тіволі. \nЗі студентства вивчила італійську мову заради її краси, почала відвідувати Італію з 2008 року, а в 2021 переїхала з Києва в Тіволі через пристрасного італійця. \nУ Римі закінчила курси гідів Mirabilia Urbis, у Папському Григоріанському Університеті відвідувала курси з «Архітектури» та «Мистецтва». \nУ 2024 отримала ліцензію тур лідера (супровід туристів), а у 2025 – європейську ліцензію гіда та офіційний дозвіл працювати в Італії. \nБезтямно закохана у Рим та Тіволі й хочу закохати вас в ці місця. \nПлануєте поїхати в Рим? Звертайтесь, з радістю стану вашим провідником у античний, гастрономічний та шопінговий світ Вічного міста. \nНаша прогулянка - це легкий, веселий та доброзичливий формат.",

  contact: {
    whatsapp: "https://wa.me/393911431549",
    instagram: "https://www.instagram.com/olha.in.italy",
    instaShort: "@olha.in.italy",
  },
};

export const tours = [
  {
    id: "c91f92cj",
    title: "Ciao, ROMA. Оглядова екскурсія Римом ",
    description:
      "Запрошую вас у подорож крізь час: тригодинну оглядову екскурсію Римом, яка подарує незабутнє знайомство з Вічним містом. \nЗа цей час ми побачимо найвідоміші пам’ятки, прогуляємося найкрасивішими вуличками, піднімімось на тераси та відчуємо справжній пульс міста, де кожен камінь дихає історією. \nМи пройдемо вузькими вуличками, де пахне кавою й історією, побачимо фасади, що змінювалися століттями, найкрасивіші площі та фонтани. І все це - у легкій, живій розповіді, з цікавинками та легендами, які оживляють кам’яну велич Риму. \nІдеально для першого знайомства з Римом. Легко, красиво, емоційно. Як сама Італія.",
    image: "/images/41.webp",
    plan: [
      "Народна площа",
      "Іспанські сходи",
      "Пантеон",
      "Площа Навона",
      "Ларго Арджентіна",
      "Площа Венеції",
      "Кампідолій",
    ],
    costs: [{ time: "3 год/до 4-х осіб", price: "250 €" }],
  },
  {
    id: "77yo7nw5",
    title: "Римські канікули - прогулянка на день",
    description:
      "Запрошую вас на захопливу прогулянку Вічним містом - це ваші римські канікули, про які хочеться розповідати друзям і згадувати ще довго! \nМи пройдемо всі головні скарби Риму: від величного Колізею й Арки Константина - до площі Навона й Пантеону, зазирнемо до античних Форумів, побачимо Ларго-Арджентіна, Кампо-дей-Фйорі, Іспанські сходи та Народну площу. \nЦе буде легка, жива і весела прогулянка з цікавинками, легендами, історіями з життя реальних людей. Ми уникатимемо натовпів, зазиратимемо в атмосферні дворики, зупинимось на перерву, щоб випити кави, скуштувати джелато або насолодитися обідом, як справжні римляни. \nЦе ідеальний формат для тих, хто хоче побачити максимум, але без поспіху й перевантаження. Красива, тепла, душевна пригода у серці Італії.",
    image: "/images/72.webp",
    plan: [
      "Колізей (ззовні)",
      "Арка Костянтина",
      "Імператорські та Римський форуми ",
      "Площа Венеції ",
      "Театр Марцелла",
      "Портик Октавії",
      "Ларго Арджентіна",
      "Форум Боаріо",
      "Острів Тіберіна",
      "Кампо дей Фйорі ",
      "Площа Навона",
      "Пантеон (ззовні)",
      "Іспанські сходи ",
      "Народна Площа",
    ],
    costs: [{ time: "", price: "80 €/год (до 4-х осіб)" }],
  },
  {
    id: "t5vyg761",
    title: "Вілла д’Есте (Тіволі)",
    description:
      "Вілла д’Есте - це сад, створений як ідеальний всесвіт: де вода замінює музику, де гроти дарують тінь і тишу, де фонтани говорять мовою міфів, влади й гармонії. Цей сад став еталоном для всієї Європи - від королівських резиденцій до приватних парків аристократії. Наша прогулянка почнеться в розписаних маньєристами залах палацу, серед салонів і фресок, де відкривається історія Тіволі, і продовжиться в саду - серед гротів і фонтанів, що зробили віллу д’Есте легендою.",
    image: "/images/Foto7.webp", // "/images/pexels-gottapics-13816327.jpg",
    costs: [
      {
        time: "2 год (до 4-x осіб)",
        price: "200 € (за бажанням можна об'єднати з візитом на віллу Адріана)",
      },
    ],
    plan: "",
  },
  {
    id: "v01d430b",
    title: "Вілла Адріана (Тіволі)",
    description:
      "Вілла Адріана - це світ, у якому архітектура, мистецтво зберігають особисту історію імператора. \nПід час прогулянки ми пройдемо імператорські зали, приватні покої, терми й ландшафти, де Адріан відтворив улюблені образи Греції та Єгипту. \nСаме з вілли Адріана походять сотні античних статуй, що сьогодні зберігаються у Ватикані, Луврі та інших європейських музеях. \nСеред них образ Антіноя - коханої людини імператора - з’являється частіше, ніж будь-який інший.",
    image: "/images/97c0993b-fe39-4040-aab7-e2b007754528.webp", // "/images/pexels-gottapics-13816327.jpg",
    costs: [
      {
        time: "2,5 год (до 4-x осіб)",
        price: "220 € (за бажанням можна об'єднати з візитом на віллу д'Есте)",
      },
    ],
    plan: "",
  },
  {
    id: "ecs7ospx",
    title: "Фуд-тур: Італія на смак",
    description:
      "Під час нашої гастрономічної прогулянки по Кампо дей Фьорі ми дізнаємось про знамениті страви римської кухні, продегустуємо піцу в античній пекарні, зробимо зупинку в м’ясній лавці, де спробуємо найсмачніші пармезан та прошуто, зайдемо в атмосферну енотеку, а також посмакуємо артішоками по-юдейські й по-римські в Єврейському гетто. А на десерт - пиріг з рікотою, тірамісу чи джелато.",
    image: "/images/pexels-unkdevil-19130186.webp",
    costs: [{ time: "2 год", price: "200 € + дегустації (від 35 євро/особа)" }],
    plan: "",
  },
  {
    id: "0apqw30k",
    title: "Арт-прогулянка «Рим геніїв та шедеврів»",
    description:
      "Рим - місто, де генії не просто творили, а боролися за ідеї, замовлення і свободу - часто поруч із папами, кардиналами та владою, яка формувала мистецтво. \nПід час цієї прогулянки ми відкриємо Рим Мікеланджело, Рафаеля, Караваджо, Берніні, Бороміні - як історію суперництва, амбіцій і сміливих рішень, що народили шедеври. \nМи побачимо твори митців в римських церквах, дізнаємося, де генії жили, а також навчимося читати приховані сенси, заховані в мармурі, картинах й скульптурах. \nМаршрут пролягає від Іспанських сходів до площі Навона - через дворики, церкви, палаци й провулки Риму.",
    image: "/images/pexels-aleksandra-zmuda-9516327-13829408.webp",
    costs: [{ time: "3 год (до 4-х осіб)", price: "250 €" }],
    plan: "",
  },
  {
    id: "a1b2c3d4",
    title: "Античний Рим",
    description:
      "Крок за кроком ми разом відтворимо Античний Рим, досліджуючи простір і уявляючи місто таким, яким воно було дві тисячі років тому.\nЗ оглядової точки ми побачимо Палатин - пагорб, де народився Рим, і поговоримо про сім царів, сім пагорбів та перші поселення.\nДалі - Великий Цирк, простір перегонів на колісницях і масових видовищ. Ми пройдемо фрагментом Тріумфальної дороги, зупинимось біля Арки Костянтина, побачимо Колізей і дізнаємось: хто і навіщо зробив його символом імперії.\nВздовж дороги, прокладеної у ХХ столітті поруч із Римським форумом, ми дійдемо до Колони Траяна - кам’яної хроніки імперії. Ми піднімемось на Капітолій - священний пагорб Риму, де стояли головні храми міста.\nДалі - Театр Марцелла, Ларго Арджентіна, місце загибелі Юлія Цезаря, і фінал біля Пантеону - ідеального простору світла, форми й математики.\nЗа три години Античний Рим складеться у вас в голові, як ідеально зібраний пазл.",
    image: "/images/antic.webp",
    plan: [],
    costs: [{ time: "3 год/до 4-х осіб", price: "250 €" }],
  },
  {
    id: "e5f6g7h8",
    title: "Куртизанки Риму",
    description:
      "Хочете побачити інший Рим - не парадний, а живий, сміливий і спокусливий? Під час цієї прогулянки ви дізнаєтеся, де в Римі 15-16 ст. жили найвідоміші куртизанки, як вони ставали частиною великої дипломатії, приймали послів і впливали на політику папського двору. \nМи говоритимемо про розквіт міста за понтифікату Олександр VI, про легендарний «Бал каштанів», про Ф’ямметту, Імперію та інших жінок, які були освіченими, музичними, блискучими співрозмовницями й володарками сердець кардиналів та банкірів.\nСаме вони дивляться на нас із полотен Рафаеля та Караваджо, закарбовані в образах Мадонн і святих у римських церквах.\nМаршрут: від Замку Святого Ангела до Кампо дей Фйорі.",
    image: "/images/fiammetta.webp",
    plan: [],
    costs: [{ time: "2 год/до 4-х осіб", price: "200 €" }],
  },
  {
    id: "i9j0k1l2",
    title: "Район Трастевере",
    description:
      "Район “по той бік Тибру”, де століттями селили чужинців, ремісників, куртизанок, моряків і тих, кого не приймав парадний центр. Тут жила одна з найдавніших єврейських громад, тут формувався робітничий і трохи зухвалий дух міста. І сьогодні в тратторіях та остеріях можна вловити атмосферу свободи, якою славився цей берег.\nМи почнемо від Piazza di Piscinula, пройдемо лабіринтом вузьких вуличок, зазирнемо у приховані дворики біля Basilica di Santa Cecilia in Trastevere і завершимо біля золотої перлини району - Basilica di Santa Maria in Trastevere. Це буде прогулянка про життя, легенди й настрій найколоритнішого району Риму.",
    image: "/images/trastevere.webp",
    plan: [],
    costs: [{ time: "3 год/до 4-х осіб", price: "250 €" }],
  },
  {
    id: "m3n4o5p6",
    title: "Єврейське гетто",
    description:
      "Під час маршруту ви побачите залишки єврейського гетто XVI століття, дізнаєтеся, як тут жили й торгували, хитрували й жартували, кохали й виживали, а у 20 ст. - рятувалися від нацистських переслідувань.\nМи пройдемо характерною Віа делла Реджинелла, зупинимося біля величного Portico d’Ottavia та вийдемо на Piazza Mattei до фонтану Черепах, де переплелися історії родин Маттеї й Костагуті.\nВи дізнаєтеся, де скуштувати легендарний пиріг із рикотою та вишнями, хрусткі carciofi alla giudia та інші страви римсько-єврейської кухні. Після цієї екскурсії гетто відкриється вам як місце сили, характеру й смаку - живий квартал, який хочеться відчути ще раз.",
    image: "/images/ghetto.webp",
    plan: [],
    costs: [{ time: "2 год/до 4-х осіб", price: "200 €" }],
  },
  {
    id: "q7r8s9t0",
    title: "Римський дівичник “Їсти, молитися, кохати”.",
    description:
      "Гуляємо затишними квартальчикам, губимося в атмосферних вуличках, п’ємо прохолодне просеко просто так -  без приводу, їмо джелато й говоримо італійські слова з акцентом. Сміємося, фотографуємося, відчуваємо легкість і дозволяємо собі справжнє dolce far niente.\nМи вийдемо на елегантну Piazza Navona, заглянемо на кінематографічну Via Margutta, смакуватимемо тірамісу з видом на площу, дегустуватимемо сири на Кампо дей Фйорі - і просто житимемо цей Рим красиво й без поспіху.\nЦе подорож для жіночої компанії - легка, яскрава, емоційна. Тут жінки розквітають, розправляють плечі й згадують, які вони красиві, сміливі й живі.\nПри бажанні до прогулянки додаємо  розкішні апартаменти в центрі Риму, трансфер з/до аеропорту, щоб ви просто насолоджувалися кожною миттю.",
    image: "/images/eat.webp",
    plan: [],
    costs: [
      { time: "", price: "80 €/год до 6 осіб" },
      {
        time: "",
        price:
          "Пакет «Трансфер, апартаменти, прогулянка» - від 140 €/особа на добу (для 6 осіб).",
      },
      {
        time: "",
        price:
          "За бажанням додається прогулянка на фіатах, гольф-карах, аперетив на терасі, кулінарні майстер-класи, йога в парку Боргезе, виїзди в передмістя тощо.",
      },
    ],
  },
  {
    id: "u1v2w3x4",
    title: "Секретний Рим",
    description:
      "Запрошую вас у подорож містом, де час сповільнюється, каміння шепоче історії, а за старими дверима ховаються справжні римські таємниці.\nМи заглянемо у тихі дворики, пройдемося вузькими вуличками, знайдемо фасади, повз які більшість проходить, навіть не підозрюючи, скільки життя вони бачили. Ви відчуєте Рим не лише очима - а на дотик, на запах, на смак. Це буде Рим без натовпів і поспіху. Рим живий, теплий, трохи іронічний.  Якщо вам близький неспішний ритм, атмосферні місця та історії, які не прочитаєш у путівнику, то ця прогулянка для вас.",
    image: "/images/secret.webp",
    plan: [],
    costs: [{ time: "3 год (до 4-х осіб)", price: "250 €" }],
  },
];

export const reviews = [
  {
    profile: "@anna__ivashyna",
    review:
      "Ольго, дуже дякуємо за проведену екскурсію, море вражень, все дуже цікаво, ми потім ще пішли на обід в місце, яке ви порекомендували (Settimio All`Arancio) нам дуже сподобалось. ",
    link: "https://www.instagram.com/anna__ivashyna/",
    avatar: "anna__ivashyna",
    place: "Україна, Київ, Запоріжжя",
  },
  {
    profile: "@yulia_lok",
    review:
      "Оля, дуже дякую за сьогоднішній день!!! Сюрприз для мами в день народження був неперевершений. Ви фантастично цікаво розказали та показали все, навіть донька в захваті… а в наш час здивувати підлітків можуть лише мега професіонали своєї справи!!!!",
    link: "https://www.instagram.com/yulia_lok/",
    avatar: "yulia_lok",
    place: "Україна",
  },
  {
    profile: "@annette_osiiuk",
    review:
      "Нам все дуже сподобалось! Дякуємо вам! Прогулянка в Римі чудова та змістовна, йдеш слухаєш насолоджуєшся, а не бігаєш по гугл карті. Тіволі теж чарівне місце, ми як заміські жителі зацінили спокій та відпочили. Ресторан - це як вишенька на торті! Нам було дуже смачно. Дякуємо за рекомендації та турботу! ",
    link: "https://www.instagram.com/annette_osiiuk/",
    avatar: "annette_osiiuk",
    place: "Україна",
  },
  {
    profile: "@elite_show",
    review:
      "Наш милий український гід у Римі, Олечка, дякуємо за наше тепле знайомство з тобою, неймовірну екскурсію, надзвичайну прихільність, захополюючі розповіді, малолюдні вулиці, таємниці історій та невідомі загалу роботи світових митців. Ти зробила Рим ще ближче для нас. Дякуємо за теплоту і легкість спілкування! Grazie mille! ",
    link: "https://www.instagram.com/elite__show/",
    avatar: "elite_show",
    place: "Україна",
  },
  {
    profile: "@ruslanaorlovska",
    review:
      "Ольга проводить класні індивідуальні екскурсії по Риму. Допомогла нам спланувати наше знайомство з давнім містом. Пояснила все по організаційних моментах, по ресторанах, кафе, транспорту тощо. Дала купу корисних посилань. Дякую! Я дуже приємно вражена!",
    link: "https://www.instagram.com/ruslanaorlovska/",
    avatar: "ruslanaorlovska",
    place: "Литва, Вільнюс",
  },
  {
    profile: "@simpa.hanna",
    review:
      "Сьогодні в нас була неймовірна ознайомча екскурсія по Риму з україномовним екскурсоводом @olha.in.italy\nЩиро рекомендую! Цікаві історії, оминали натовпи туристів затишними вуличками, побачили немовірну кількість пам’яток. Перше знайомство з вічним містом вдалось! ",
    link: "https://www.instagram.com/simpa.hanna/",
    avatar: "simpa_hanna",
    place: "Україна",
  },
  {
    profile: "@mariia.mohina",
    review:
      "Дякуємо за неймовірний день, за цей нетуристичний, а справжній Рим, який цікавий не головними вуличками, а таємничими провулками, де ти знаходеш найкращу історію. Олічко, дуже тобі дякуємо за сьогоднішній день! ",
    link: "https://www.instagram.com/mariia.mohina/",
    avatar: "mariia_mohina",
    place: "Україна",
  },
  {
    profile: "Катерина",
    review:
      "Ольго, хочу вам подякувати за проведений з вами час. Це було дуже цікаво і дорослим і дитині. А це показник неабиякий. \nЯкщо б дивились Рим самі, то по-перше не розуміли б що дивимось. А по друге такі місця туристам знати нереально. Тому тим, хто сумнівається  - не сумнівайтесь! Беріть екскурсію у Ольги. Це дійсно круто!!!! Ще раз дякую! ",
    link: "",
    avatar: "pexels-unchalee-srirugsar-14114-85773",
    place: "Україна, Миколаїв ",
  },
  {
    profile: "@udgen1302",
    review:
      "Олічко, хочу сказати вам величезне дякую! Ви найкращий гід Італії! Ви закохали нас в це місто. У нас дуже багато вражень та величезних позитивних емоцій! Величезне вам дякую! ",
    link: "https://www.instagram.com/udgen1302/",
    avatar: "udgen1302",
    place: "Україна, Одеса",
  },
];
